import React from 'react';
import PropTypes from 'prop-types';

import NumberFormat from 'react-number-format';

function PriceFormatOnlyNumbersField(props) {
  const { inputRef, disabled, ...other } = props;

  return (
    <NumberFormat
      {...other}
      allowLeadingZeros
      allowNegative={false}
      decimalScale={2}
      disabled={disabled}
      fixedDecimalScale
      getInputRef={inputRef}
    />
  );
}

PriceFormatOnlyNumbersField.propTypes = {
  disabled: PropTypes.bool,
  inputRef: PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.node]),
};

export default PriceFormatOnlyNumbersField;
